export const nav = {
  allAds: "All listings",
  createAd: "Create listing",
  pricing: "Pricing",
  tips: "Tips",
  about: "About Sellavo",
  help: "Help and support",
  inboxUnread: "Inbox – {{count}} unread. Open the inbox to read them.",
  inboxUnreadTitle: "{{count}} unread{{suffix}} – open the inbox to mark them as read",
  adminPending: "{{count}} admin items waiting{{support}}",
  adminPendingSupport: " – of which {{count}} support",
  sellavoHome: "Sellavo – back to the start page",
} as const;

export const footer = {
  colSellavo: "Sellavo",
  colTrade: "Selling and buying",
  colLegal: "Legal",
  om: "About Sellavo",
  howItWorks: "How it works",
  whyItCosts: "Why does it cost?",
  pricing: "Pricing",
  tips: "Tips",
  guides: "Guides",
  buyAndSellLocally: "Buy and sell in your area",
  compare: "Compare selling sites",
  rules: "Listing rules",
  videoScan: "Video scanning",
  help: "Help and support",
  terms: "Terms of use",
  privacy: "Privacy policy",
  cookies: "Cookie policy",
  cookieSettings: "Cookie settings",
  tagline: "Snap a photo, let AI write the listing, and sell fast and nice.",
} as const;

export const errors = {
  notFoundTitle: "Page not found",
  notFoundBody: "The address you tried to reach does not exist, or the page has moved.",
  offlineTitle: "No connection",
  offlineBody:
    "We can't reach Sellavo right now. Check your connection and try again — pages you visited before still work.",
  busyTitle: "Busy right now",
  busyBody: "There are more visitors than usual on Sellavo. Wait a few seconds and try again.",
  errorTitle: "The page could not load",
  errorBody: "Something went wrong on our side. Try reloading the page or going back to the start page.",
} as const;
